const HANDLE = /^[A-Za-z0-9]{2,64}$/;

export class ShopInputError extends Error {
  readonly code = "invalid_shop_input";
}

function validateHandle(value: string): string {
  const handle = value.trim().replace(/^@/, "");
  if (!HANDLE.test(handle)) throw new ShopInputError("Enter an Etsy shop URL or shop handle.");
  return handle;
}

export function parseEtsyShopHandle(input: string): string {
  const value = String(input ?? "").trim();
  if (!value) throw new ShopInputError("Enter an Etsy shop URL or shop handle.");
  if (!value.includes("://") && !value.includes("/")) return validateHandle(value);

  let url: URL;
  try {
    url = new URL(value.includes("://") ? value : `https://${value}`);
  } catch {
    throw new ShopInputError("That does not look like a valid Etsy shop URL.");
  }

  const hostname = url.hostname.toLowerCase();
  if (hostname !== "etsy.com" && !hostname.endsWith(".etsy.com")) {
    throw new ShopInputError("Only Etsy shop URLs are supported.");
  }

  const segments = url.pathname.split("/").filter(Boolean);
  const shopIndex = segments.findIndex((segment) => segment.toLowerCase() === "shop");
  if (shopIndex < 0 || !segments[shopIndex + 1]) {
    throw new ShopInputError("Use a shop URL such as etsy.com/shop/ShopName.");
  }
  return validateHandle(decodeURIComponent(segments[shopIndex + 1]!));
}
